import React, { useState } from 'react';
import { photos } from '../data/mock';
import { X } from 'lucide-react';

const Photos = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  return (
    <div>
      <h1 className="text-2xl font-serif mb-8">Photos</h1>

      {/* Filter Tags */}
      <div className="flex gap-3 mb-8 pb-6 border-b border-[#1f1f23]">
        <button className="text-sm text-white font-medium">
          All
        </button>
      </div>

      {/* Photo Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
        {photos.map((photo) => (
          <button
            key={photo.id}
            onClick={() => setSelectedPhoto(photo)}
            className="aspect-square overflow-hidden rounded-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#050505]"
          >
            <img
              src={photo.src}
              alt={photo.alt}
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
            />
          </button>
        ))}
      </div>

      {/* Lightbox Modal */}
      {selectedPhoto && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedPhoto(null)}
        >
          <button
            onClick={() => setSelectedPhoto(null)}
            className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"
          >
            <X size={24} />
          </button>
          <img
            src={selectedPhoto.src.replace('w=400&h=300', 'w=1200&h=900')}
            alt={selectedPhoto.alt}
            className="max-w-full max-h-[90vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default Photos;
